import * as React from 'react';
export const IcRecycling = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.23 13.36a1 1 0 001 .76h.24a1 1 0 00.74-1.2l-.66-2.75a1 1 0 00-1.24-.77l-2.75.66A1 1 0 105 12l.37-.08L2.3 17A2 2 0 004 20h4a1 1 0 100-2H4l3.13-5.08.1.44zm7.31-4.23L14 9a1.025 1.025 0 10-.45 2l2.75.64h.23a1 1 0 00.53-.15 1 1 0 00.44-.62l.64-2.76a1 1 0 10-1.95-.45l-.07.3L13.7 4a2 2 0 00-3.4 0L8.61 6.69a1 1 0 101.7 1.05L12 5l2.54 4.13zM21.7 17l-2.14-3.48a1 1 0 00-1.7 1L20 18h-5.59l.3-.29a1.004 1.004 0 10-1.42-1.42l-2 2a1.001 1.001 0 000 1.42l2 2a.997.997 0 001.095.219.999.999 0 00.325-.219 1 1 0 000-1.42l-.3-.29H20a2 2 0 001.7-3z'
      fill='currentColor'
    />
  </svg>
);
